import { pagesConfig } from '../../../shared/pages-config';
import SignatureTemplatesGrid from './signature-templates-grid';
import { useUserSettings } from '../../../utils/use-user-settings';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';
import { Outlet, useSearchParams } from 'react-router-dom';
import { useRouteMatch } from '../../../shared/useRouteMatch';
import { useCallback } from 'react';
import { SignatureModel } from '../../../../types';

export default function SignatureTemplatesPage() {
  const { toolsRoles, changeLogRoles } = useUserSettings();
  const [, setSearchParams] = useSearchParams();

  const handleDetails = useCallback(
    (template: SignatureModel) => {
      setSearchParams((prev) => {
        prev.set('selectedTemplate', template.id.toString());
        return prev;
      });
    },
    [setSearchParams]
  );

  const isFormPage = useRouteMatch([
    `${pagesConfig.signatureTemplates.link}/${pagesConfig.createSignatureTemplate.link}`,
    `${pagesConfig.signatureTemplates.link}/${pagesConfig.editSignatureTemplate.link}`,
    `${pagesConfig.signatureTemplates.link}/${pagesConfig.cloneSignatureTemplate.link}`,
  ]);
  if (isFormPage) return <Outlet />;
  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.automation.name },
        { label: pagesConfig.signatureTemplates.name },
      ]}
      bookmarkKey={pagesConfig.signatureTemplates.value}
    >
      <SignatureTemplatesGrid
        toolsRoles={toolsRoles}
        changeLogRoles={changeLogRoles}
        onViewDetails={handleDetails}
      />
    </SimpleBreadcrumbsPage>
  );
}
